export const RolePermissions = Object.freeze({
  manage: "manage",
  view: "view",
});

export const ProductVisibility = Object.freeze({
  public: "public",
  private: "private",
});
